import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TraslateService } from "src/app/traslate.service";
import { NgxSpinnerService } from "ngx-spinner";
import { LocalService } from "src/app/local.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { FormControl, FormGroup } from "@angular/forms";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ThemeService } from "ng2-charts";
import { Observable } from "rxjs";
import { DOCUMENT } from "@angular/common";

import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";
import { PushNotificationsService } from "ng-push-ivy";
import { FileSaverService } from "ngx-filesaver";

declare var $;

pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var require: any;

@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.scss"],
})
export class ReportComponent implements OnInit {
  descr_veh: boolean = true;
  descr_fl_veh: boolean;
  desc_det_veh: boolean;

  mode = "vehicule";
  modee2 = "";
  desc_fl_cond: boolean;
  desc_det_cond: boolean;
  myModel = true;

  veh: boolean = true;
  scr: boolean = true;
  scr2: boolean = true;
  URL: string;
  URL1: string;
  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();

  rangeForm = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
    end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
  });

  rap_fl_v: boolean;
  rap_d_v: boolean;

  rap_fl_c: boolean;
  rap_d_c: boolean;

  todo: any = [];

  done: any = [];

  lengthTotal: any;
  repos: any;
  dataSource: any;
  units: any;
  score_sfty_v1: any;
  score_sfty_v2: any;
  score_eco_v1: any;
  score_eco_v2: any;
  operator: any;
  operator1: any;
  operator2: any;
  operator3: any;
  test: any[] = [];
  DateStart: string;
  DateEnd: string;
  url: any;
  spinnerActive: boolean;
  op1: any[] = [];
  op2: any[] = [];
  myObjStr: string;
  typerep: number;
  desc_fl_cond2: boolean;
  radioStatus: boolean;
  sfScMoy: any;

  scoresaf: any;
  scoreeco: any;

  slides = {
    name: "STG DRIVE RAPPORT",
    url: "http://173.249.47.12/stgdrive/public/uploads/pdf/135/rapport_v1.pdf",
  };

  @Input()
  urlSafe: SafeResourceUrl;
  ecScMoy: any;
  downoaldReport: Object;
  hide: boolean = false;

  constructor(
    private _FileSaverService: FileSaverService,
    private _pushNotifications: PushNotificationsService,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    public traslateService: TraslateService,
    private http: HttpClient,
    private spinnerreportUser: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this._pushNotifications.requestPermission();
  }

  ngOnInit(): void {
    this.scoresaf = "null";
    this.scoreeco = "null";
  }

  generatePdf() {
    /* const documentDefinition = { content: 'This is an sample PDF printed with pdfMake' };
    pdfMake.createPdf(documentDefinition).open(); */
    this.score_sfty_v1 = document.getElementById("score_sfty_v1");
    this.score_sfty_v2 = document.getElementById("score_sfty_v2");
    this.score_eco_v1 = document.getElementById("score_eco_v1");
    this.score_eco_v2 = document.getElementById("score_eco_v2");

    let res: any[] = [
      parseInt(this.score_sfty_v1.value),
      parseInt(this.score_sfty_v2.value),
    ];
    let res1: any[] = [
      parseInt(this.score_eco_v1.value),
      parseInt(this.score_eco_v2.value),
    ];
    this.op1 = [this.operator, this.operator1];
    this.op2 = [this.operator2, this.operator3];

    //console.log(res)
    //console.log(res1)
    //console.log(this.op1)
    //console.log(this.op2)
    //console.log(this.operator)

    this.generate(
      this.test,
      this.op1,
      res,
      this.op2,
      res1,
      this.mode,
      this.sfScMoy,
      this.ecScMoy
    );
  }
  show_veh() {
    this.descr_veh = true;
    this.mode = "vehicule";
    this.modee2 = "";
    this.desc_fl_cond = false;

    this.rap_fl_v = false;
    this.rap_d_v = false;

    this.rap_fl_c = false;
    this.rap_d_c = false;
    //console.log(this.mode)
    this.todo = [];
    this.done = [];
  }

  resetFormScore() {
    this.operator = null;
    this.operator1 = null;
    this.operator2 = null;
    this.operator3 = null;
    this.scoresaf = "null";
    this.scoreeco = "null";
    (<HTMLFormElement>document.getElementById("score_sfty_v1")).value = null;
    (<HTMLFormElement>document.getElementById("score_sfty_v2")).value = null;
    (<HTMLFormElement>document.getElementById("score_eco_v1")).value = null;
    (<HTMLFormElement>document.getElementById("score_eco_v2")).value = null;
    this.remove();
  }

  executeFunction() {
    //console.log(this.rangeForm)

    this.addNewDate(this.rangeForm);
  }

  addNewDate(e) {
    this.DateStart = new Date(e.value.start)
      ?.toString()
      .split("(")[0]
      .split("GMT")[0];
    //this.minDate = new Date(e.value.start)

    //var DateEnd2 = new Date(e.value.end)?.toISOString();
    this.DateEnd = new Date(e.value.end)
      ?.toString()
      .split("(")[0]
      .split("GMT")[0];
    //console.log(this.DateStart, this.DateEnd)
  }

  getdd(e1, e2) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/scores/vehicles/all/filter/" +
      e1 +
      "~" +
      e2;

    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listvehiculee: any = response;

        this.lengthTotal = listvehiculee.length;

        this.repos = listvehiculee.units;
        //console.log(this.repos)

        let resultid: any[] = [];

        for (let e in this.repos) {
          resultid.push({ id: this.repos[e].id, name: this.repos[e].name });

          //this.todo.push(this.repos[e].name)
        }

        this.todo = resultid;
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }
  getdd1(e1, e2) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/scores/drivers/all/filter/" +
      e1 +
      "~" +
      e2;

    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listconducteur: any = response;

        this.lengthTotal = listconducteur.length;

        this.repos = listconducteur.drivers;
        //console.log(this.repos)

        let resultid: any[] = [];

        for (let e in this.repos) {
          resultid.push({ id: this.repos[e].id, name: this.repos[e].name });

          //this.todo.push(this.repos[e].name)
        }

        this.todo = resultid;
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }
  listvehicule() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/units/all";
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listvehiculee: any = response;

        this.lengthTotal = listvehiculee.length;

        this.repos = listvehiculee.vehicles;
        //console.log(this.repos)

        let resultid: any[] = [];
        let result: any[] = [];
        for (let e in this.repos) {
          resultid.push({ id: this.repos[e].id, name: this.repos[e].name });
          result.push(this.repos[e].name);
          //this.todo.push(this.repos[e].name)
        }

        //console.log(resultid)
        this.todo = resultid;
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }

  example($event) {
    this.radioStatus = false;
  }

  getValuesf(e) {
    //console.log(e)
    this.sfScMoy = e;
  }
  getValueec(e) {
    //console.log(e)
    this.ecScMoy = e;
  }

  test1() {
    var radios: any = document.getElementById("ScoreScore");

    //console.log(this.sfScMoy, radios.value)
  }
  listcond() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/drivers/all";
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listconducteurs: any = response;

        this.lengthTotal = listconducteurs.length;

        this.repos = listconducteurs.drivers;
        //console.log(this.repos)

        let resultid: any[] = [];

        for (let e in this.repos) {
          resultid.push({ id: this.repos[e].id, name: this.repos[e].name });
          //this.todo.push(this.repos[e].name)
        }

        this.todo = resultid;
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });

        this.spinnerreportUser.hide();
      }
    );
  }

  show_fl_cond() {
    this.desc_fl_cond = true;
    this.mode = "conducteur";
    this.modee2 = "";
    this.descr_veh = false;

    this.rap_fl_v = false;
    this.rap_d_v = false;

    this.rap_fl_c = false;
    this.rap_d_c = false;
    //console.log(this.mode)
    this.todo = [];
    this.done = [];
  }
  show_vehicule() {
    this.veh = !this.veh;
  }
  show_score() {
    this.scr = !this.scr;
  }
  show_score2() {
    this.scr2 = !this.scr2;
  }

  show_report_fl_v() {
    this.modee2 = "Rapportdeflotte";
    this.rap_fl_v = true;
    this.rap_d_v = false;

    this.rap_fl_c = false;
    this.rap_d_c = false;

    this.descr_veh = false;

    this.desc_fl_cond = false;
    this.desc_fl_cond2 = false;
    this.descr_fl_veh = false;

    this.done = [];
    // this.mode = "vehicule";
    this.listvehicule();
  }

  show_report_det_v() {
    this.modee2 = "Rapportdetaille";
    this.rap_fl_v = false;
    this.rap_d_v = true;

    this.rap_fl_c = false;
    this.rap_d_c = false;

    this.descr_veh = false;

    this.desc_fl_cond = false;
    this.desc_fl_cond2 = false;
    this.desc_det_veh = false;

    this.done = [];
    // this.mode = "vehicule";
    //console.log(this.rap_fl_v)
    //console.log(this.mode)

    this.listvehicule();
  }

  show_report_fl_c() {
    this.rap_fl_v = false;
    this.rap_d_v = false;

    this.rap_fl_c = true;
    this.rap_d_c = false;

    this.descr_veh = false;

    this.desc_fl_cond = false;
    this.desc_fl_cond2 = false;

    this.done = [];

    this.listcond();
  }
  show_report_det_c() {
    this.modee2 = "Rapportdetaille";
    this.rap_fl_v = false;
    this.rap_d_v = false;

    this.rap_fl_c = false;
    this.rap_d_c = true;

    this.descr_veh = false;

    this.desc_fl_cond = false;
    this.desc_fl_cond2 = false;
    this.desc_det_cond = false;

    this.done = [];

    this.listcond();
  }

  show_report_detflet_c() {
    this.modee2 = "Rapportdeflotte";
    // this.rap_fl_v = false;
    // this.rap_d_v = false;

    // this.rap_fl_c = false;
    // this.rap_d_c = true;

    // this.descr_veh = false;

    // this.desc_fl_cond = false;
    // this.desc_fl_cond2 = false;
    // this.desc_det_cond = false;

    this.rap_fl_v = true;
    this.rap_d_v = false;

    this.rap_fl_c = false;
    this.rap_d_c = false;

    this.descr_veh = false;

    this.desc_fl_cond = false;
    this.desc_fl_cond2 = false;
    this.descr_fl_veh = false;

    this.done = [];

    this.listcond();
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      //console.log(this.todo)
      //console.log(this.done)
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      //console.log(this.todo)
      //console.log(this.done)
      //console.log(event.container.data)
      this.test = [];
      for (let e in this.done) {
        this.test.push(this.done[e].id);
      }

      //console.log(this.test)
    }
  }

  objSec(operators, values, avg) {
    //const obj = JSON.stringify({operators,value})
    return { operators, values, avg };
  }
  objEco(operators, values, avg) {
    //const obj1 = JSON.stringify({operators,value})
    return { operators, values, avg };
  }
  generatefav(
    arr,
    operatorssf,
    valuesf,
    operators_eco,
    value_eco,
    mode,
    avg_sf,
    avg_ec
  ) {
    //console.log(this.sfScMoy)
    //console.log(this.ecScMoy)
    let safety_score = this.objSec(operatorssf, valuesf, avg_sf);
    let eco_score = this.objEco(operators_eco, value_eco, avg_ec);
    if (mode == "vehicule") {
      var units = arr;
      this.myObjStr = JSON.stringify({ units, safety_score, eco_score });
      //console.log(encodeURI(this.myObjStr))
      //console.log(this.myObjStr)
    } else {
      var drivers = arr;
      this.myObjStr = JSON.stringify({ drivers, safety_score, eco_score });
      //console.log(encodeURI(this.myObjStr))
      //console.log(this.myObjStr)
    }
  }

  popupGeneration(title, body, icon) {
    this._pushNotifications
      .create(title, {
        body: body,
        icon: icon,
      })
      .subscribe((res) => {
        if (res.event.type === "click") {
          res.notification.close();
        }
      });
  }

  generate(
    arr,
    operatorssf,
    valuesf,
    operators_eco,
    value_eco,
    mode,
    avg_sf,
    avg_ec
  ) {
    //console.log(this.sfScMoy)
    //console.log(this.ecScMoy)
    let safety_score = this.objSec(operatorssf, valuesf, avg_sf);
    let eco_score = this.objEco(operators_eco, value_eco, avg_ec);

    ////console.log(this.rap_d_v)

    if (mode == "vehicule") {
      var units = arr;
      this.myObjStr = JSON.stringify({ units, safety_score, eco_score });
      //console.log(encodeURI(this.myObjStr))
      //console.log(this.myObjStr)
    } else {
      var drivers = arr;
      this.myObjStr = JSON.stringify({ drivers, safety_score, eco_score });
      //console.log(encodeURI(this.myObjStr))
      //console.log(this.myObjStr)
    }

    if (this.rap_d_v == true) {
      this.typerep = 2;
    } else if (this.rap_fl_v == true) {
      this.typerep = 1;
    } else if (this.rap_d_c == true) {
      this.typerep = 2;
    } else {
      this.typerep = 1;
    }

    const headerDict = {
      "Content-Type": "application/pdf",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
      responseType: "blob",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var DateFilterStart = new Date(this.rangeForm.value.start)
      .toString()
      .split("GMT")[0];
    var DateFilterEnd = new Date(this.rangeForm.value.end)
      .toString()
      .split("GMT")[0];
    var concat = DateFilterStart + "~" + DateFilterEnd;
    //console.log(concat)

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/reports/type/" +
      this.typerep +
      "/filter/" +
      concat +
      "/criteria/" +
      encodeURI(this.myObjStr);
    //console.log(this.URL)
    let options = {
      body: "La demande de génération de rapport a été envoyée au serveur. Vous serez notifié lorsque le rapport sera disponible.",
      icon: "https://www.searchpng.com/wp-content/uploads/2019/02/Reload-Blue-Icon-PNG.png",
    };
    // Swal.fire({
    //   icon: 'success',
    //   title: 'Le rapport seront générés dans quelques instants',

    // });
    let timerInterval;
    Swal.fire({
      title: "Le rapport sera généré dans quelques instants",
      html: "Attendez s'il vous plaît",
      // timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        // const b = Swal.getHtmlContainer().querySelector('b')
        // timerInterval = setInterval(() => {
        //   // b.textContent = Swal.getTimerLeft()
        // }, 100)

        this._pushNotifications
          .create(
            "Rapport en cours " + new Date().toLocaleDateString(),
            options
          )
          .subscribe(
            (res) => {
              this.http.get(this.URL, requestOptions).subscribe(
                (response) => {
                  //console.log(response)
                  Swal.close();

                  Swal.fire({
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: "success",
                    title: "Rapport généré avec succès",
                    toast: true,
                    timerProgressBar: true,
                  });

                  var resp: any = response;

                  var url: any = resp.url;

                  this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
                    resp.url
                  );

                  if (url != null) {
                    res.notification.close();
                    this.downoaldNotifications(resp.url).bind(this);
                  }

                  this.traslateService.urlPathQuote.next(this.urlSafe);
                },
                (error) => {
                  Swal.fire({
                    text: "Un problème est survenu! " + error,
                  });

                  this.spinnerreportUser.hide();
                }
              );
            },
            (err) => console.log(err)
          );
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log("I was closed by the timer");
      }
    });
  }

  downoaldNotifications(e): any {
    this._pushNotifications
      .create("Rapport disponible " + new Date(), {
        body: "Le rapport est terminé cliquer pour téléchargé",
        icon: "https://www.ontariohealthstudy.ca/wp-content/uploads/2019/02/pdf.png",
      })
      .subscribe((res) => {
        if (res.event.type === "click") {
          //console.log(res); //console.log(e);

          var link = document.createElement("a");

          link.href = e;
          link.download =
            "Rapport STG DRIVE" + new Date().toLocaleDateString() + ".pdf";
          link.dispatchEvent(new MouseEvent("click"));
          res.notification.close();
        }
      });
  }

  downloadFile() {
    var url: any =
      "https://nils-mehlhorn.de/slides/mobile_cp_progessive_mehlhorn_pottjs.pdf";
    let headers = new HttpHeaders();
    headers = headers.set("Accept", "application/pdf");
    //console.log(this.http.get(url, { headers: headers, responseType: 'blob' as 'json' }))
    return this.http.get(url, {
      headers: headers,
      responseType: "blob" as "json",
    });
  }

  move() {
    /* this.done=this.todo
    this.todo=[]
     */

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/units";
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listvehiculee: any = response;

        this.lengthTotal = listvehiculee.length;

        this.repos = listvehiculee.vehicles;

        let resultid: any[] = [];

        for (let e in this.repos.data) {
          resultid.push({
            id: this.repos.data[e].id,
            name: this.repos.data[e].name,
          });

          this.test.push(this.repos.data[e].id);
        }

        this.done = resultid;

        this.todo = [];
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }

  addfav() {
    this.score_sfty_v1 = document.getElementById("score_sfty_v1");
    this.score_sfty_v2 = document.getElementById("score_sfty_v2");
    this.score_eco_v1 = document.getElementById("score_eco_v1");
    this.score_eco_v2 = document.getElementById("score_eco_v2");

    let res: any[] = [
      parseInt(this.score_sfty_v1.value),
      parseInt(this.score_sfty_v2.value),
    ];
    let res1: any[] = [
      parseInt(this.score_eco_v1.value),
      parseInt(this.score_eco_v2.value),
    ];
    this.op1 = [this.operator, this.operator1];
    this.op2 = [this.operator2, this.operator3];

    //res.push(this.score_sfty_v1.value)

    //console.log(res)
    //console.log(res1)
    //console.log(this.op1)
    //console.log(this.op2)
    //console.log(this.operator)

    //console.log(this.rap_d_v)
    //console.log(this.rap_fl_v)
    //console.log(this.rap_d_c)
    //console.log(this.rap_fl_c)

    this.generatefav(
      this.test,
      this.op1,
      res,
      this.op2,
      res1,
      this.mode,
      this.sfScMoy,
      this.ecScMoy
    );
    if (this.rap_d_v == true) {
      this.typerep = 2;
      this.rap_fl_c = false;
      this.rap_d_c = false;
    } else if (this.rap_fl_v == true) {
      this.typerep = 1;
      this.rap_fl_c = false;
      this.rap_d_c = false;
    } else if (this.rap_d_c == true) {
      this.typerep = 2;
      this.rap_fl_v = false;
      this.rap_d_v = false;
    } else {
      this.typerep = 1;
      this.rap_fl_v = false;
      this.rap_d_v = false;
    }

    var DateFilterStart = new Date(this.rangeForm.value.start)
      .toString()
      .split("GMT")[0];
    var DateFilterEnd = new Date(this.rangeForm.value.end)
      .toString()
      .split("GMT")[0];
    var concat = DateFilterStart + "~" + DateFilterEnd;
    //console.log(concat)

    Swal.fire({
      title: "Veillez saisir le nom de votre Favoris",
      input: "text",
      imageUrl:
        "https://cdn.dribbble.com/users/282075/screenshots/4756098/icon_reward.gif",
      //instead of imageSize use imageWidth and imageHeight

      imageHeight: 200,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      cancelButtonText: "Annuler",
      confirmButtonText: "Enregistrer Favoris",
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      background: "#fdfdfe",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        var obj: any = {
          name: login,
          type: this.typerep,
          filter: concat,
          criteria: this.myObjStr,
        };
        //console.log(obj)
        this.spinnerreportUser.show();
        //console.log(this.rap_d_v)
        //console.log(this.rap_fl_v)
        //console.log(this.rap_d_c)
        //console.log(this.rap_fl_c)
        return this.http
          .post(environment.apiUrl + "/reports/favorite", obj)
          .subscribe(
            (data) => {
              var response: any = data;

              if (response.status == 200) {
                //console.log(response)
                this.spinnerreportUser.hide();
              }
            },
            (error) => {
              Swal.fire({
                text: "Un problème est survenu! " + error,
              });

              this.spinnerreportUser.hide();
            }
          );
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Votre nouveau rapport favoris est enregistré avec succès",
        });
      }
    });
  }

  remove() {
    /* this.todo=this.done
    this.done=[] */

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/units";
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listvehiculee: any = response;

        this.lengthTotal = listvehiculee.length;

        this.repos = listvehiculee.vehicles;
        //console.log(this.repos)

        let resultid: any[] = [];

        for (let e in this.repos.data) {
          resultid.push({
            id: this.repos.data[e].id,
            name: this.repos.data[e].name,
          });
          //this.test.push(this.repos[e].id)
        }

        this.todo = resultid;
        this.done = [];
        this.test = [];
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }

  move1() {
    /* this.done=this.todo
    this.todo=[]
     */

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/drivers";
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listvehiculee: any = response;

        this.lengthTotal = listvehiculee.length;

        this.repos = listvehiculee.drivers;
        //console.log(this.repos)

        let resultid: any[] = [];

        for (let e in this.repos) {
          resultid.push({ id: this.repos[e].id, name: this.repos[e].name });

          this.test.push(this.repos[e].id);
        }
        //console.log(resultid)
        this.done = resultid;
        this.todo = [];
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }
  remove1() {
    /* this.todo=this.done
    this.done=[] */

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL =
      environment.apiUrl +
      "/companies/" +
      JSON.parse(localStorage.getItem("currentUser")).company_id +
      "/drivers";
    this.http.get(this.URL, requestOptions).subscribe(
      (response) => {
        var listvehiculee: any = response;

        this.lengthTotal = listvehiculee.length;

        this.repos = listvehiculee.drivers;
        //console.log(this.repos)

        let resultid: any[] = [];

        for (let e in this.repos) {
          resultid.push({ id: this.repos[e].id, name: this.repos[e].name });

          //this.todo.push(this.repos[e].name)
        }
        //console.log(resultid)
        this.todo = resultid;
        this.done = [];
        this.test = [];
        //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }
}

@Component({
  selector: "PdfDom",
  templateUrl: "./PdfDom.html",
  styleUrls: ["./report.component.scss"],
})
export class PdfDomComponent implements OnInit {
  url: any;

  constructor(public traslateService: TraslateService) {}
  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe((data) => {
      this.url = data;
    });
  }
}
